import React, { FC } from 'react'

const QuestionMarkIcon: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width={16}
        height={17}
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M6.58594 5.51256C7.36699 4.82915 8.63332 4.82915 9.41436 5.51256C10.1954 6.19598 10.1954 7.30402 9.41436 7.98744C9.27842 8.10639 9.12778 8.20463 8.96755 8.28217C8.47043 8.52276 8.00015 8.94772 8.00015 9.5V10M14 8.5C14 11.8137 11.3137 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5ZM8 12H8.005V12.005H8V12Z"
            stroke="#185E8E"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default QuestionMarkIcon
